import { IPoint } from '@/contract/map.base'

/**
 * 国测局gcj02地理坐标点转换成百度地图Bd09地理坐标点
 * @param {Point} point 国测局gcj02地理坐标点
 * @returns {Point} 百度地图Bd09地理坐标点
 */
export const gcj02ToBd09 = (point: IPoint): IPoint => {
  const xPI = (Math.PI * 3000.0) / 180.0
  const z =
    Math.sqrt(point.lng * point.lng + point.lat * point.lat) + 0.00002 * Math.sin(point.lat * xPI)
  const theta = Math.atan2(point.lat, point.lng) + 0.000003 * Math.cos(point.lng * xPI)
  const bdLng = z * Math.cos(theta) + 0.0065
  const bdLat = z * Math.sin(theta) + 0.006
  return { lng: bdLng, lat: bdLat }
}

/**
 * 百度地图Bd09地理坐标点转换成国测局gcj02地理坐标点
 * @param {Point} point 百度地图Bd09地理坐标点
 * @returns {Point} 国测局gcj02地理坐标点
 */
export const bd09toGcj02 = (point: IPoint): IPoint => {
  const xPI = (Math.PI * 3000.0) / 180.0
  const x = point.lng - 0.0065
  const y = point.lat - 0.006
  const z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * xPI)
  const theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * xPI)
  const gcLng = z * Math.cos(theta)
  const gcLat = z * Math.sin(theta)
  return { lng: gcLng, lat: gcLat }
}
